import React from 'react'
import Menu from './menu'
import { ReactComponent as Burguer } from '../../icons/menu.svg'
import { ReactComponent as LogoMobile } from '../../icons/logo_mobile.svg'
import styled from 'styled-components'

const OpenIcon = styled(Burguer)`
  position: fixed;
  top: 1rem;
  right: 1rem;
  width: 2rem;
  height: 2rem;
  background: #0397ab;
  fill: #fff;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  z-index: 11;
`

const Logo = styled(LogoMobile)`
  position: fixed;
  top: 2rem;
  left: 2rem;
  z-index: 11;
`

const Nav = ({ open }) => (
  <>
    <a id="Logo" href="https://telxius.com">
      <Logo />
    </a>
    <OpenIcon id="Hamburguer" onClick={() => open()} />
  </>
)

const Navigation = ({ mobile, open, close, state, urlTo }) => {
  return (
    <>
      {mobile ? <Nav id="Hamburguer" open={open} state={state} /> : undefined}
      <Menu mobile={mobile} close={close} state={state} urlTo={urlTo} />
    </>
  )
}

export default Navigation
